import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  districts: [],
  district: null,
  filteredDistrictsData: [],
  districtTotalItems: null
}

// mutations
export const mutations = {
  [types.SET_DISTRICTS] (state, payload) {
    payload.data ? state.districts = payload.data : state.districts = payload
    payload.data ? state.districtTotalItems = payload.total : state.districtTotalItems = null
  },
  [types.SET_DISTRICT] (state, district) {
    state.district = district
  },
  [types.FETCH_DISTRICT_FAILURE] (state) {
    state.district = null
  },
  filterDistricts (state, data) {
    state.filteredDistrictsData = data
  }
}

// actions
export const actions = {
  async fetchDistricts ({ commit }, payload) {
    try {
      const { data } = await axios.get('/districts?include=municipality', {
        params: payload ? payload.query : ''
      })
      commit(types.SET_DISTRICTS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchDistrict ({ commit }, district) {
    try {
      const { data } = await axios.get(`/districts/${district.id}`)

      commit(types.SET_DISTRICT, { district: data })
    } catch (e) {
      commit(types.FETCH_DISTRICT_FAILURE)
    }
  },

  async createDistrict (context, district) {
    try {
      await axios.post('/api/districts', district)
      context.dispatch('fetchDistricts')
    } catch (e) {
      console.log(e)
    }
  },

  async updateDistrict (context, district) {
    try {
      await axios.put(`/api/districts/${district.id}`, district)
      context.dispatch('fetchDistricts')
    } catch (e) { }
  },

  async deleteDistrict (context, district) {
    try {
      await axios.delete(`/api/districts/${district.id}`)
      context.dispatch('fetchDistricts')
    } catch (e) { }
  }
}

// getters
export const getters = {
  districts: state => state.districts,
  getDistrictByMunicipalityId: (state) => (id) => {
    return state.districts.filter(district => district.municipality_id === id)
  },
  filteredDistrictsData: state => state.filteredDistrictsData,
  districtTotalItems: state => state.districtTotalItems
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/district.js